import React from 'react';
import Piece from './Piece';

const Square = ({ index, isLight, piece, embodiment, dukeSkin, pieceSkin, isSelected, isLegalMove, onClick }) => {
  const file = index % 8;
  const rank = Math.floor(index / 8);
  
  // Determine if this is a capture move (legal move to an occupied square)
  const isCapture = isLegalMove && piece;
  const isEmptyMove = isLegalMove && !piece;
  
  // Apply appropriate classes for move indicators
  const squareClass = `chess-square ${
    isLight ? 'light' : 'dark'
  } ${isSelected ? 'selected' : ''} ${isEmptyMove ? 'legal-move' : ''} ${isCapture ? 'legal-capture' : ''}`;

  return (
    <div
      className={squareClass}
      onClick={onClick}
      data-testid={`square-${index}`}
      style={{
        gridColumn: file + 1,
        gridRow: 8 - rank
      }}
    >
      {piece && <Piece type={piece.type} side={piece.side} embodiment={embodiment} dukeSkin={dukeSkin} pieceSkin={pieceSkin} />}
    </div>
  );
};

export default Square;
